import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { userLogout } from '../../actions/AuthenticationActions';
import { getIsLoggedInSelector, getUserNeedsRecertificationSelector } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { useAppDispatch } from '../services/store/useAppDispatch';

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const recert = useSelector(getUserNeedsRecertificationSelector);
  return useCallback(
    (event?: any) => {
      event?.preventDefault();
      if (isLoggedIn || recert) {
        dispatch(userLogout());
        history.push('/sign-in');
      }
    },
    [dispatch, history, isLoggedIn, recert]
  );
};
